import { getQaSelector } from '../../../../../utils/common'
import { Skeleton } from '../../../../Skeleton'
import {
  LISTING_BOARD_SKELETON_CARDS,
  QA_NAME_LISTING_BOARD_SKELETON_CARD,
} from '../RentalPortalListingsBoard.constants'

import * as styles from './RentalPortalListingsBoardSkeleton.module.css'

function RentalPortalListingsBoardSkeleton() {
  return LISTING_BOARD_SKELETON_CARDS.map(skeletonCard => (
    <div
      {...getQaSelector({ value: QA_NAME_LISTING_BOARD_SKELETON_CARD })}
      className={styles.RentalPortalListingsBoardSkeleton}
      key={skeletonCard}
    >
      <Skeleton className={styles.cover} />
      <div className={styles.body}>
        <Skeleton className={styles.title} />
        <Skeleton className={styles.meta} />
      </div>
    </div>
  ))
}

export default RentalPortalListingsBoardSkeleton
